const isCookiebotEnabled = (): boolean => {
    return window?.Cookiebot;
};

const californiaRegionCode = 'us-06';
const isCookiebotConsented = function (type: string): boolean {
    if (!isCookiebotEnabled()) {
        return false;
    }

    const userResponseSubmitted = window.Cookiebot.hasResponse;
    const isCalifornia =
        window.Cookiebot?.userCountry?.toLowerCase() === californiaRegionCode;
    if (!userResponseSubmitted && isCalifornia) {
        // Regardless of actual consent we treat CA users as accepting all cookies by default until they choose to accept cookies
        return true;
    }

    switch (type) {
        case 'necessary':
            return window.Cookiebot?.consent?.necessary;
        case 'preferences':
            return window.Cookiebot?.consent?.preferences;
        case 'statistics':
            return window.Cookiebot?.consent?.statistics;
        case 'marketing':
            return window.Cookiebot?.consent?.marketing;
        default:
            console.error('Unknown cookiebot type', type);
            return false;
    }
};

const onCookiebotConsentChange = (callback: () => void) => {
    onMounted(() => {
        if (typeof window === 'undefined') return;

        window.addEventListener('CookiebotOnAccept', callback);
        window.addEventListener('CookiebotOnDecline', callback);
    });

    onUnmounted(() => {
        if (typeof window === 'undefined') return;

        window.removeEventListener('CookiebotOnAccept', callback);
        window.removeEventListener('CookiebotOnDecline', callback);
    });
};

const showCookiebotBanner = () => {
    if (isCookiebotEnabled()) {
        window.Cookiebot.show();
    }
};

export function useCookiebot() {
    return {
        isCookiebotEnabled,
        isCookiebotConsented,
        onCookiebotConsentChange,
        showCookiebotBanner,
    };
}
